import React from 'react';
import styled from 'styled-components';


const getTextColor = (color) => {
    const blackFontColorCriteria = new Set(['#ffffff', '#efeacb', '#fbf5c5'])
    if (blackFontColorCriteria.has(String.prototype.toLocaleLowerCase.call(color))) {
        return 'black';
    }
    return 'white';
}

const StyledText = styled.p`
    color: ${props => getTextColor(props.background)};
`;

const ColorBlockButton = ({
    background,
    displayName,
}) => {

    return (
        <div
            className={'b-rit-block-button block-button-theme--threads'}
            style={{ background }}>
            <StyledText background={background}>
                {displayName}
            </StyledText>
        </div>
    );
}


export default ColorBlockButton;